import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectionCheckbox", "inviteCheckbox"]
  static values = { importable: Boolean }

  connect() {
    this.syncInviteState()
  }

  selectionChanged() {
    if (!this.importableValue) return

    if (!this.selectionCheckboxTarget.checked) {
      this.uncheckInvite()
    }

    this.syncInviteState()
  }

  syncInviteState() {
    if (!this.hasInviteCheckboxTarget) return

    if (!this.importableValue) {
      this.inviteCheckboxTarget.disabled = true
      return
    }

    this.inviteCheckboxTarget.disabled = !this.selectionCheckboxTarget.checked
  }

  uncheckInvite() {
    if (!this.hasInviteCheckboxTarget) return
    if (!this.inviteCheckboxTarget.checked) return

    this.inviteCheckboxTarget.checked = false
    this.inviteCheckboxTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
